import React from "react";

/* ------------------------------------------------------------------------
 * The single flag component. Every flag in the banner renders through this —
 * card flag, vehicle roof flags — so there are no stacked colour divs.
 *
 * 3:2 ratio, three equal bands in the official colours, navy #000080 Chakra
 * sized to 3/4 of the white band. The 24 spokes are drawn as 12 full
 * diameters at 15deg apart, which is exactly 24 evenly spaced radii.
 * ---------------------------------------------------------------------- */

export default function IndiaFlag({
    className = "id-flag-svg",
    width,
    /* Defaults reproduce the flag exactly as it has always drawn: 12 full
     * diameters = 24 spokes. Callers rendering below ~20px wide pass fewer,
     * heavier spokes — at header size 24 of them blur into a solid disc. */
    spokes = 12,
    strokeWidth = 5,
    chakraStroke = 9,
}) {
    /* Without `width` the flag fills its container via .id-flag-svg, which is
     * how the hero roof flags, the hero card and the popup size it. Callers
     * that sit inline with text (the login badge and country-code chip) have
     * no sized box to fill, so they pass a width and get an explicit 3:2 box
     * instead. `flex: none` stops a flex parent squashing it. */
    const style = width
        ? { width: `${width}px`, height: `${(width * 2) / 3}px`, flex: "none" }
        : undefined;

    return (
        <svg
            viewBox="0 0 900 600"
            preserveAspectRatio="none"
            className={className}
            style={style}
            role="img"
            aria-label="Flag of India"
        >
            <rect width="900" height="200" fill="#FF9933" />
            <rect y="200" width="900" height="200" fill="#FFFFFF" />
            <rect y="400" width="900" height="200" fill="#138808" />
            <g transform="translate(450 300)">
                <circle r="75" fill="none" stroke="#000080" strokeWidth={chakraStroke} />
                <circle r="15" fill="#000080" />
                <g stroke="#000080" strokeWidth={strokeWidth} strokeLinecap="round">
                    {Array.from({ length: spokes }, (_, k) => (
                        <line
                            key={k}
                            x1="0"
                            y1="-75"
                            x2="0"
                            y2="75"
                            transform={`rotate(${(k * 180) / spokes})`}
                        />
                    ))}
                </g>
            </g>
        </svg>
    );
}

/** Ashoka Chakra on its own — badge icon and background watermark. */
export function AshokaChakra({ className = "", stroke = "#1A3A8F" }) {
    return (
        <svg viewBox="0 0 200 200" className={className} aria-hidden="true" focusable="false">
            <circle cx="100" cy="100" r="88" fill="none" stroke={stroke} strokeWidth="6" />
            <circle cx="100" cy="100" r="13" fill={stroke} />
            <g stroke={stroke} strokeWidth="4" strokeLinecap="round">
                {Array.from({ length: 12 }, (_, k) => (
                    <line
                        key={k}
                        x1="100"
                        y1="12"
                        x2="100"
                        y2="188"
                        transform={`rotate(${k * 15} 100 100)`}
                    />
                ))}
            </g>
        </svg>
    );
}
